import {Component} from '@angular/core';
import {Button} from 'primeng/button';
import {Card} from 'primeng/card';

@Component({
  selector: 'theme-preview-page',
  imports: [
    Button,
    Card
  ],
  templateUrl: './theme-preview-page.html',
  styleUrl: './theme-preview-page.scss'
})
export class ThemePreviewPage {

  // Button severities for iteration in template
  public readonly severities: Array<{ name: string; value: 'secondary' | 'success' | 'info' | 'warn' | 'help' | 'danger' | 'contrast' | null }> = [
    { name: 'Default', value: null },
    { name: 'Secondary', value: 'secondary' },
    { name: 'Success', value: 'success' },
    { name: 'Info', value: 'info' },
    { name: 'Warn', value: 'warn' },
    { name: 'Help', value: 'help' },
    { name: 'Danger', value: 'danger' },
    { name: 'Contrast', value: 'contrast' }
  ];

  // Icon mapping for icon-only buttons
  public readonly iconMap: Record<string, string> = {
    'Default': 'pi pi-check',
    'Secondary': 'pi pi-bookmark',
    'Success': 'pi pi-search',
    'Info': 'pi pi-user',
    'Warn': 'pi pi-bell',
    'Help': 'pi pi-heart',
    'Danger': 'pi pi-times',
    'Contrast': 'pi pi-eye'
  };
}
